import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toothlensLogo from "../../assets/illustrations/Toothlens Logo.jpeg";
import { exchangeSsoCode } from '../../Services/APIs/patient';
import { startInsuranceSession } from '../../Utils/insuranceSession';

// Landing page for sign-in links created by a client app (POST /portal/sso).
// The link carries a one-time code; redeeming it signs the member in without a passcode.
const SsoLogin = () => {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const started = useRef(false);

  useEffect(() => {
    // A code works only once, so never redeem it twice (React may run effects twice in development).
    if (started.current) return;
    started.current = true;

    const code = new URLSearchParams(window.location.search).get('code');
    // Take the code out of the address bar and browser history straight away.
    window.history.replaceState(null, '', window.location.pathname);

    if (!code) {
      setFailed(true);
      return;
    }

    exchangeSsoCode(code)
      .then((response) => {
        const member = response.data?.data;
        if (!member?.employee_mail) {
          setFailed(true);
          return;
        }
        startInsuranceSession(member.employee_mail, member);
        navigate('/', { replace: true });
      })
      .catch(() => setFailed(true));
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex flex-col items-center justify-center px-4 py-8">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-gray-200">
        <div className="bg-gradient-to-r from-indigo-600 to-violet-600 p-8 text-center">
          <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4 p-2">
            <img src={toothlensLogo} alt="ToothLens Logo" className="w-full h-full object-contain rounded-full" />
          </div>
          <h1 className="text-2xl font-bold text-white">Welcome to ToothLens</h1>
        </div>

        <div className="p-8 text-center">
          {failed ? (
            <>
              <h2 className="text-lg font-semibold text-gray-800 mb-2">
                This sign-in link has expired or is invalid
              </h2>
              <p className="text-sm text-gray-500">
                Please go back to your app and open ToothLens again.
              </p>
            </>
          ) : (
            <div className="flex flex-col items-center space-y-4">
              <div className="w-10 h-10 border-4 border-indigo-600 border-t-transparent rounded-full animate-spin"></div>
              <p className="text-sm font-semibold text-gray-700">Signing you in…</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SsoLogin;
